// ของที่หน้าเช็คขาดสอบ / สรุปผู้เข้าสอบ / รายชื่อผู้ขาดสอบใช้ร่วมกัน
// ช่วงสอบ = รายการปฏิทินที่ประเภทเป็น "สอบ" (ดู server/models/examAbsenceModel.js)
import { useEffect, useState } from 'react';
import axiosInstance from '../services/axiosInterceptor';
import { toThaiDateLong } from '../utils/thaiDate';

export const API = process.env.REACT_APP_API || 'http://localhost:3002/api';

export const STATUS = {
  present: { text: 'มา', long: 'มาสอบ', variant: 'success' },
  late: { text: 'สาย', long: 'มาสาย', variant: 'warning' },
  leave: { text: 'ลา', long: 'ลา', variant: 'info' },
  absent: { text: 'ขาด', long: 'ขาดสอบ', variant: 'danger' },
};
export const STATUS_KEYS = ['present', 'late', 'leave', 'absent'];

export const apiError = (error) => error?.response?.data?.message || error?.message || 'ลองใหม่อีกครั้ง';

// ผู้เข้าสอบ = มาสอบ + มาสาย ต่อคนในห้องที่เช็คแล้ว
export const attendPct = (row) => {
  const total = Number(row?.total) || 0;
  if (!total) return null;
  return ((Number(row.present) + Number(row.late)) / total) * 100;
};
export const fmtPct = (v) => (v == null ? '–' : `${v.toFixed(v === 100 ? 0 : 1)}%`);

const WEEKDAYS = ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'];

export const dayLabel = (ymd, { short = true } = {}) => {
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-').map(Number);
  return `${WEEKDAYS[new Date(y, m - 1, d).getDay()]}. ${toThaiDateLong(ymd, { short })}`;
};

export const eventRange = (ev) =>
  ev ? (ev.start_date === ev.end_date ? dayLabel(ev.start_date) : `${dayLabel(ev.start_date)} – ${dayLabel(ev.end_date)}`) : '';

// ช่วงสอบมีสองภาค — สอบสามัญ (cal_type exam) แล้วต่อด้วยสอบศาสนา (exam_islamic)
export const TRACK_LABEL = { general: 'สามัญ', islamic: 'ศาสนา' };
export const eventName = (ev) => (ev ? `[${TRACK_LABEL[ev.track] || ''}] ${ev.cal_title}` : '');

// รายการช่วงสอบที่ผู้ใช้เห็นได้ — แต่ละรายการมี canManage (เจ้าของข้อมูลของภาคนั้น: เลือกวัน
// ย้อนหลังได้ ไม่ล็อก) เจ้าของข้อมูลได้ทุกช่วงของภาคตัวเอง คนอื่นได้เฉพาะช่วงที่กำลังสอบ
export const useExamEvents = () => {
  const [state, setState] = useState({ loading: true, events: [], canViewAbsent: false, error: null });
  useEffect(() => {
    let alive = true;
    axiosInstance.get(`${API}/exam-absence/events`)
      .then(({ data }) => alive && setState({ loading: false, error: null, ...data }))
      .catch((err) => alive && setState((s) => ({ ...s, loading: false, error: apiError(err) })));
    return () => { alive = false; };
  }, []);
  return state;
};

// ช่วงสอบที่เลือกอยู่: จาก ?cal= ถ้ามี ไม่งั้นช่วงที่กำลังสอบวันนี้ ไม่งั้นช่วงล่าสุด
export const pickEvent = (events, calParam, today) => {
  const byParam = events.find((e) => String(e.cal_id) === String(calParam));
  if (byParam) return byParam;
  return events.find((e) => e.start_date <= today && e.end_date >= today) || events[0] || null;
};
